import { useEffect } from 'react';

const APP_NAME = 'Photon PACS';

/**
 * Sets the browser tab title as "<section> · <detail> | Photon PACS".
 *
 * The distinguishing part (section, then patient) comes first because browsers
 * truncate long tab titles from the end — with the editor, viewer and PACS list
 * all open side by side, "Photon PACS" first would make every tab look the same.
 */
export function setPageTitle(section?: string | null, detail?: string | null) {
  const label = [section, detail].filter(Boolean).join(' · ');
  document.title = label ? `${label} | ${APP_NAME}` : APP_NAME;
}

export function usePageTitle(section?: string | null, detail?: string | null) {
  useEffect(() => {
    setPageTitle(section, detail);
  }, [section, detail]);
}

/** Render-nothing wrapper so route elements can set a title without their own hook. */
export function PageTitle({ section, detail }: { section?: string | null; detail?: string | null }) {
  usePageTitle(section, detail);
  return null;
}
